const CSRF_COOKIE = /(?:^|;\s*)_csrf_token=([^;]*)/;

// Heimdal seeds this cookie on the login screen's first paint, so the resolver
// can sit behind SeaSurf like every other POST.
function readCsrfCookie() {
  const match =
    typeof document === 'undefined' ? null : document.cookie.match(CSRF_COOKIE);
  return match && match[1] ? decodeURIComponent(match[1]) : undefined;
}

export default function TenantSourceService({
  baseUrl,
  http,
  getCsrfToken = readCsrfCookie,
}) {
  const PATH_RESOLVE_TENANT = '/resolveTenant';

  return {
    resolveTenant,
  };

  function resolveTenant({ email }) {
    return http.postAuthenticated({
      url: `${baseUrl}${PATH_RESOLVE_TENANT}`,
      body: {
        email,
      },
      csrf_token: getCsrfToken(),
    });
  }
}
